import { Box, Button, Typography, } from '@mui/material';
import React from 'react';
import styled from '@emotion/styled';


const Para = styled(Typography)`
font-size: 18px;
 margin-bottom: 1rem;
 line-height: normal;
@media(max-width: 599px){
        font-size: 16px;

    }
`


const Paragraph = (props) => {
  return ( 
  <Para  {...props} > {props.children} </Para>
  );
}
 
export default Paragraph;